import "./Divisions.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import DivisionsGrid from "./sections/DivisionsGrid";
import Footer from "@/reusable_sections/Footer";
export default function DivisionsPage() {
  return <div>
      <Header />
      <HeroBanner />
      <DivisionsGrid />
      <Footer />
    </div>;
}